import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function Pricing() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-white">
      <div className="mx-auto max-w-[800px] px-6 md:px-10">
        <ScrollReveal direction="up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 border border-primary-200/50 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-4">
            {t('phoenix.pricingTag')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-16 text-center">
            Una inversión <span className="text-primary-500">inteligente</span> para tu negocio.
          </h2>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.15}>
          <div className="rounded-3xl bg-white border border-background-200/70 shadow-[0_4px_32px_rgba(0,0,0,0.04)] overflow-hidden">
            <div className="p-8 md:p-10">
              <div className="space-y-4">
                {[
                  { label: t('phoenix.pricingMentoring'), value: t('phoenix.price'), line: true },
                  { label: t('phoenix.pricingMentoringNormal'), value: t('phoenix.pricingMentoringNormalValue'), line: false },
                  { label: t('phoenix.pricingPrompts'), value: t('phoenix.pricingPromptsValue'), line: false },
                ].map((row, i) => (
                  <div key={i} className={`flex items-center justify-between py-3 ${row.line ? 'border-b border-background-200 pb-4' : ''}`}>
                    <span className="text-foreground-600 text-base">{row.label}</span>
                    <span className="text-foreground-800 font-semibold text-base">{row.value}</span>
                  </div>
                ))}
              </div>

              <div className="mt-6 pt-6 border-t-2 border-background-300 flex items-center justify-between">
                <span className="text-foreground-800 font-bold text-lg">{t('phoenix.pricingTotal')}</span>
                <span className="text-foreground-400 font-semibold text-lg line-through">241.9 USD</span>
              </div>
            </div>

            <div className="bg-gradient-to-r from-primary-500 to-primary-600 p-8 md:p-10 text-white">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
                <div>
                  <p className="text-white/80 text-sm mb-1">{t('phoenix.pricingToday')}</p>
                  <div className="flex items-baseline gap-2">
                    <span className="font-heading text-4xl md:text-5xl font-bold">{t('phoenix.price')}</span>
                  </div>
                  <p className="text-white/70 text-xs mt-1 flex items-center gap-1">
                    <i className="ri-arrow-down-line"></i>
                    {t('phoenix.pricingSave')}
                  </p>
                </div>
                <a
                  href="https://wa.link/em25v1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-primary-600 font-bold text-sm hover:bg-white/95 transition-all duration-300 whitespace-nowrap shadow-[0_4px_20px_rgba(0,0,0,0.2)] hover:shadow-[0_6px_28px_rgba(0,0,0,0.3)] hover:-translate-y-0.5 cursor-pointer"
                >
                  {t('phoenix.ctaPrimary')}
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}